import { AVAILABLE_LOCALIZATIONS, DEFAULT_LANGUAGE, DEFAULT_NAVIGATOR_LANGUAGE } from 'constants/localization';

export const getNavigatorLanguage = () => {
    const languages = navigator.languages || [];
    const language = languages[0] || navigator.language || DEFAULT_NAVIGATOR_LANGUAGE;

    return language?.split('-')[0];
};

export const getLocalizationFromAvailable = () => {
    const navigatorLanguage = getNavigatorLanguage();

    const isLanguageLocalized = AVAILABLE_LOCALIZATIONS.includes(navigatorLanguage);

    return isLanguageLocalized ? navigatorLanguage : DEFAULT_LANGUAGE;
};

export const getCurrentLocalization = () => {
    const routerLang = window.location.pathname.split('/')[1];

    const isLanguageLocalized = AVAILABLE_LOCALIZATIONS.includes(routerLang);

    return isLanguageLocalized ? routerLang : DEFAULT_LANGUAGE;
};
